/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoAppSearchAppSearchData model module.
 * @module model/CampaignControllerDtoAppSearchAppSearchData
 * @version 1.0
 */
class CampaignControllerDtoAppSearchAppSearchData {
    /**
     * Constructs a new <code>CampaignControllerDtoAppSearchAppSearchData</code>.
     * @alias module:model/CampaignControllerDtoAppSearchAppSearchData
     */
    constructor() { 
        
        CampaignControllerDtoAppSearchAppSearchData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppSearchAppSearchData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppSearchAppSearchData} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppSearchAppSearchData} The populated <code>CampaignControllerDtoAppSearchAppSearchData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppSearchAppSearchData();

            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('profileImage')) {
                obj['profileImage'] = ApiClient.convertToType(data['profileImage'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppSearchAppSearchData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppSearchAppSearchData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['profileImage'] && !(typeof data['profileImage'] === 'string' || data['profileImage'] instanceof String)) {
            throw new Error("Expected the field `profileImage` to be a primitive type in the JSON string but got " + data['profileImage']);
        }

        return true;
    }


}



/**
 * @member {Number} appNo
 */
CampaignControllerDtoAppSearchAppSearchData.prototype['appNo'] = undefined;

/**
 * @member {String} title
 */
CampaignControllerDtoAppSearchAppSearchData.prototype['title'] = undefined;

/**
 * @member {String} packageName
 */
CampaignControllerDtoAppSearchAppSearchData.prototype['packageName'] = undefined;

/**
 * @member {String} profileImage
 */
CampaignControllerDtoAppSearchAppSearchData.prototype['profileImage'] = undefined;






export default CampaignControllerDtoAppSearchAppSearchData;

